// import * as XLSX from 'xlsx';

// export function downloadExcelTemplate() {
//     // Define the headers you need
//     const headers = [
//         'ת.ז.',
//         'שם פרטי',
//         'משפחה',
//         'כתובת',
//         'אימייל',
//         'פלאפון',
//         'עסקן מקשר',
//         "פלא' עסקן מקשר",
//         // 'תאריך הצטרפות',
//         'פרוט מקרה',
//         'הערות',
//         'שם ספק',
//         'אופן תשלום',
//         'סעיף',
//         'סכום',
//         'תאריך פעולה',
//         'הערות לפעולה'
//     ];

//     const worksheet = XLSX.utils.aoa_to_sheet([headers]);
//     worksheet['!sheetViews'] = [{ rightToLeft: true }];
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, 'תלמידים');
//     workbook.Workbook = {
//         Views: [{ RTL: true }]
//     };
//     XLSX.writeFile(workbook, 'תבנית_תלמידות.xlsx');
// }

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export async function downloadExcelTemplate() {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('תלמידים', {
        views: [{ rightToLeft: true }]
    });

    // הגדרת הכותרות
    const headers = [
        'ת.ז.', 'שם פרטי', 'שם משפחה', 'כתובת', 'אימייל', 'פלאפון',
        'מורה מקשרת', "פלא' מורה מקשרת", 'דירוג מקרה', 'הערות',
        'שם ספק', 'תשלום לספק', 'תשלום לנתמך', 'תאריך שיק', 'מספר שיק',
        'סכום שיק', 'סעיף', 'סוג סיוע ורווחה', 'מספר מפגשים', 'תאריכי מפגשים',
        'סכום', 'תאריך פעולה', 'הערות לפעולה'
    ];

    worksheet.addRow(headers);
    const caseDetailColIndex = 9;
    const supplierPaymentColIndex = 12; // תשלום לספק
    const beneficiaryPaymentColIndex = 13; // תשלום לנתמך
    const categoryColIndex = 17; // סעיף
    const welfareSubcategoryColIndex = 18; // סוג סיוע ורווחה

    // הוספת אימות נתונים ל-100 השורות הראשונות (ניתן להגדיל לפי הצורך)
    for (let i = 2; i <= 100; i++) {
        // מקרה
        const caseCell = worksheet.getCell(i, caseDetailColIndex);
        caseCell.dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: ['"קל,קשה"'] // הערכים לבחירה
        };

        // תשלום לספק
        const supplierPaymentCell = worksheet.getCell(i, supplierPaymentColIndex);
        supplierPaymentCell.dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: ['"העברה בנקאית לספק"']
        };

        // תשלום לנתמך
        const beneficiaryPaymentCell = worksheet.getCell(i, beneficiaryPaymentColIndex);
        beneficiaryPaymentCell.dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: ['"שובר קנייה,העברה בנקאית ישירה,שיק,תמיכה שוות כסף"']
        };

        // סעיף
        const categoryCell = worksheet.getCell(i, categoryColIndex);
        categoryCell.dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: ['"סיוע ורווחה,הכנסת כלה,שכ""ל,כולל,אחר"']
        };

        // סוג סיוע ורווחה
        const welfareSubcategoryCell = worksheet.getCell(i, welfareSubcategoryColIndex);
        welfareSubcategoryCell.dataValidation = {
            type: 'list',
            allowBlank: true,
            formulae: ['"טיפול ע""י מטפל,סיוע כספי פרטי"']
        };
    }

    // יצירת הקובץ והורדה בדפדפן
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, 'תבנית_תלמידות.xlsx');
}
